<app-loading-game-controls-view
  [hasUnfinishedRoom]="hasUnfinishedRoom()"
  [unfinishedTimeRemaining]="unfinishedTimeRemaining()"
  [fetchHints]="fetchHints"
  [playButtonLabel]="playButtonLabel()"
  (playButtonClickedEvent)="onPlayButtonClicked()"
/>
